import React, { useState } from "react";
import { api, arabicError } from "../lib/api";
import { toast } from "sonner";
import { X, Star } from "lucide-react";

const RateModal = ({ reservationId, otherName, isSeller, onClose, onRated }) => {
  const [stars, setStars] = useState(0);
  const [hover, setHover] = useState(0);
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    if (!stars) { toast.error("اختر عدد النجوم"); return; }
    setSubmitting(true);
    try {
      await api.post("/ratings", { reservation_id: reservationId, stars });
      toast.success("شكراً لك، تم إرسال التقييم");
      onRated?.(stars);
      onClose();
    } catch (e) { toast.error(arabicError(e)); }
    finally { setSubmitting(false); }
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={onClose} dir="rtl">
      <div className="bg-white rounded-2xl max-w-sm w-full p-6" onClick={(e) => e.stopPropagation()} data-testid="rate-modal">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-extrabold text-[#333333]">
            قيّم {isSeller ? "المشتري" : "البائع"}
          </h3>
          <button onClick={onClose} data-testid="close-rate-modal" className="w-9 h-9 rounded-lg hover:bg-[#EBF4F6] flex items-center justify-center"><X size={18} /></button>
        </div>
        <p className="text-sm text-[#666666] mb-4">كيف كانت تجربتك مع <span className="font-bold text-[#333333]">{otherName || "التاجر"}</span>؟</p>
        <div className="flex items-center justify-center gap-2 mb-6" dir="ltr" data-testid="rate-stars">
          {[1, 2, 3, 4, 5].map((i) => (
            <button key={i} type="button" data-testid={`rate-star-${i}`}
              onClick={() => setStars(i)}
              onMouseEnter={() => setHover(i)}
              onMouseLeave={() => setHover(0)}
              className="p-1 transition-transform hover:scale-110">
              <Star size={34} className={i <= (hover || stars) ? "text-amber-400 fill-amber-400" : "text-gray-300"} />
            </button>
          ))}
        </div>
        <button onClick={submit} disabled={submitting || !stars} data-testid="rate-submit"
          className="h-12 w-full rounded-lg bg-[#09637E] hover:bg-[#088395] text-white font-extrabold disabled:opacity-50">
          {submitting ? "جارٍ الإرسال..." : "إرسال التقييم"}
        </button>
      </div>
    </div>
  );
};

export default RateModal;
